export const READ = 'PRICE/READ'
export const READ_BY_DATE = 'PRICE/READ_BY_DATE'
export const RESET = 'PRICE/RESET'
export const SET = 'PRICE/SET'
export const SET_LIVE_CALLBACK = 'PRICE/SET_LIVE_CALLBACK'
export const SET_RANGE = 'PRICE/SET_RANGE'
export const SET_SUBSCRIBED = 'PRICE/SET_SUBSCRIBED'
export const UPDATE = 'PRICE/UPDATE'
export const TOGGLE_EXPANDED = 'PRICE/TOGGLE_EXPANDED'
export const STOP = 'PRICE/STOP'
